/* =========================================================
   PRODUCT DETAIL PAGE — product.js
   Reads variant data from #pdp-data (rendered by product.liquid)
   and drives gallery, variant picker, price/stock, add-to-cart.
   Mirrors the original product-page.js behavior.
   ========================================================= */
(function () {
  var dataEl = document.getElementById('pdp-data');
  var pdpEl = document.getElementById('pdp');
  if (!dataEl || !pdpEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var options = data.options || [];
  var variants = (data.variants || []).map(function (v) {
    var map = {};
    options.forEach(function (opt, i) { map[opt.name] = v.options[i]; });
    v._map = map;
    return v;
  });

  /* ---------- Gallery ---------- */
  var heroImg = document.getElementById('pdp-hero-img');
  var counterEl = document.getElementById('pdp-counter');
  var thumbsEl = document.getElementById('pdp-thumbs');
  var prevBtn = document.getElementById('pdp-prev');
  var nextBtn = document.getElementById('pdp-next');

  var thumbBtns = [].slice.call(thumbsEl.querySelectorAll('.pdp__thumb'));
  var images = thumbBtns.map(function (b) { return b.dataset.full; });
  var currentIdx = 0;

  function setImage(idx) {
    if (!images.length) return;
    if (idx < 0) idx = images.length - 1;
    if (idx >= images.length) idx = 0;
    currentIdx = idx;
    heroImg.src = images[idx];
    if (images.length > 1) { counterEl.textContent = (idx + 1) + ' / ' + images.length; }
    thumbBtns.forEach(function (t) {
      t.classList.toggle('pdp__thumb--active', parseInt(t.dataset.idx, 10) === idx);
    });
  }

  if (images.length > 1) {
    counterEl.textContent = '1 / ' + images.length;
    prevBtn.addEventListener('click', function () { setImage(currentIdx - 1); });
    nextBtn.addEventListener('click', function () { setImage(currentIdx + 1); });
    thumbsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.pdp__thumb');
      if (!btn) return;
      setImage(parseInt(btn.dataset.idx, 10));
    });
  } else {
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
    if (images.length <= 1) thumbsEl.style.display = 'none';
  }

  /* ---------- Variants ---------- */
  var hasRealOptions = !(options.length === 1 && options[0].values.length === 1 && options[0].values[0] === 'Default Title');

  var selectedOptions = {};
  var currentVariant = null;
  for (var i = 0; i < variants.length; i++) { if (variants[i].available) { currentVariant = variants[i]; break; } }
  if (!currentVariant) currentVariant = variants[0];

  if (currentVariant) {
    options.forEach(function (opt) { selectedOptions[opt.name] = currentVariant._map[opt.name]; });
  }

  function findVariant(selected) {
    return variants.find(function (v) {
      return options.every(function (opt) { return v._map[opt.name] === selected[opt.name]; });
    });
  }

  function renderOptions() {
    var container = document.getElementById('pdp-options');
    container.innerHTML = options.map(function (opt) {
      return '<div class="pdp__option-group">' +
        '<label class="pdp__option-label">' + opt.name + '</label>' +
        '<div class="pdp__option-values">' +
          opt.values.map(function (val) {
            var isActive = selectedOptions[opt.name] === val;
            var test = Object.assign({}, selectedOptions);
            test[opt.name] = val;
            var match = findVariant(test);
            var isAvailable = match ? match.available : true;
            return '<button type="button" class="pdp__option-btn' +
              (isActive ? ' pdp__option-btn--active' : '') +
              (!isAvailable ? ' pdp__option-btn--unavailable' : '') +
              '" data-option="' + opt.name + '" data-value="' + val + '">' + val + '</button>';
          }).join('') +
        '</div>' +
      '</div>';
    }).join('');
  }

  function updatePriceAndStock(v) {
    var priceEl = document.getElementById('pdp-price');
    var compareEl = document.getElementById('pdp-compare');
    var stockEl = document.getElementById('pdp-stock');
    var addBtn = document.getElementById('pdp-add');
    if (!v) return;

    priceEl.textContent = formatMoney(v.price);

    if (v.compare_at_price && v.compare_at_price > v.price) {
      compareEl.textContent = formatMoney(v.compare_at_price);
      compareEl.style.display = 'inline';
    } else {
      compareEl.style.display = 'none';
    }

    if (v.available) {
      stockEl.textContent = 'In Stock';
      stockEl.className = 'pdp__stock pdp__stock--in';
      addBtn.disabled = false;
      addBtn.querySelector('.btn__label').textContent = 'Add to cart';
    } else {
      stockEl.textContent = 'Sold Out';
      stockEl.className = 'pdp__stock pdp__stock--out';
      addBtn.disabled = true;
      addBtn.querySelector('.btn__label').textContent = 'Sold out';
    }
    addBtn.dataset.variantId = v.id;
  }

  if (hasRealOptions && options.length > 0) {
    renderOptions();
    document.getElementById('pdp-options').addEventListener('click', function (e) {
      var btn = e.target.closest('.pdp__option-btn');
      if (!btn) return;
      selectedOptions[btn.dataset.option] = btn.dataset.value;
      currentVariant = findVariant(selectedOptions) || currentVariant;
      updatePriceAndStock(currentVariant);

      if (currentVariant.image) {
        var matchIdx = images.indexOf(currentVariant.image);
        if (matchIdx >= 0) { setImage(matchIdx); }
        else { heroImg.src = currentVariant.image; }
      }
      renderOptions();
    });
  }

  updatePriceAndStock(currentVariant);

  /* ---------- Quantity ---------- */
  var qty = 1;
  var qtyVal = document.getElementById('qty-val');
  document.getElementById('qty-minus').addEventListener('click', function () {
    if (qty > 1) { qty--; qtyVal.textContent = qty; }
  });
  document.getElementById('qty-plus').addEventListener('click', function () {
    qty++; qtyVal.textContent = qty;
  });

  /* ---------- Add to cart (honors quantity) ---------- */
  var addBtn = document.getElementById('pdp-add');
  addBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var variantId = addBtn.dataset.variantId;
    if (!variantId || addBtn.disabled || !window._3dpm) return;

    addBtn.disabled = true;
    var label = addBtn.querySelector('.btn__label');
    var origText = label.textContent;
    label.textContent = 'Adding…';

    window._3dpm.addVariant(variantId, qty)
      .then(window._3dpm.getCart)
      .then(function (cart) {
        window._3dpm.renderCart(cart);
        window._3dpm.bumpBadge();
        window._3dpm.openDrawer();
      })
      .catch(function (err) { console.warn('Add to cart failed:', err); })
      .then(function () { addBtn.disabled = false; label.textContent = origText; });
  });
})();
